import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import TabSwitch from './tabSwitch';
import Content from './content';
import Chip from 'Chip';

class Slide extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    state = {
        type: 0,
        showArrow: false,
    };

    tabChange = type => {
        this.setState({ type });
    };

    onArrow = type => {
        this.setState({ type });
    };

    handleData = content => {
        const { slidesTab, slideContent } = content;

        const result = [];

        Object.values(slideContent).forEach((item, index) => {
            item = item[0];

            item.id = slidesTab[index].id;
            result.push(item);
        });

        return result;
    };

    mouseEnter = () => {
        this.setState({ showArrow: true });
    };

    mouseLeave = () => {
        this.setState({ showArrow: false });
    };

    render() {
        const { type, showArrow } = this.state;
        const { content } = this.props;

        const { slidesTab } = content;

        // 处理数据
        const data = this.handleData(content);
        const len = data.length;

        const typeNum = Number(type);
        const otherTab = {
            tabChange: this.tabChange,
            type: typeNum,
            showArrow,
            len,
        };

        const otherContent = {
            onArrow: this.onArrow,
            showArrow,
            type: typeNum,
            len,
        };

        const isData = Array.isArray(data) && data.length > 0;

        return (
            <div id="newsSlide" className={styles.wrap} onMouseEnter={this.mouseEnter} onMouseLeave={this.mouseLeave}>
                <Chip
                    id="50102"
                    type="struct"
                    title="要闻区右栏轮播图标题栏"
                    groupName="要闻区右栏轮播图"
                    content={slidesTab}>
                    <TabSwitch content={slidesTab} other={otherTab} />
                </Chip>
                {isData &&
                    data.map((item, index) => (
                        <Chip
                            key={index}
                            id={item.id}
                            type="recommend"
                            title={`要闻区右栏轮播图${slidesTab[index].title}`}
                            groupName="要闻区右栏轮播图"
                            content={[item]}
                            translate="handleIndexSlideData"
                            position="relative">
                            <Content other={otherContent} index={index} />
                        </Chip>
                    ))}
            </div>
        );
    }
}

export default errorBoundary(Slide);
